import { Form, Row, Col, Image, Button, Table, Modal } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import {
  TextField,
  FormControl,
  Select,
  InputLabel,
  IconButton,
  MenuItem,
} from "@material-ui/core";
import { Toggle } from "../../../../components/superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import ReadMore from "../../../reusableComponents/ReadMore";

const AddedPackages = ({ data, editPackage, deletePackage, onPackageStatusChange, ageRestriction }) => {
  return (
    <>
      <Col md={12}>
        <Row>
          <Col md={3}>
            <div className="f10-400 opacity5">Package Name</div>
            <div className="f12-500 my-2">{data.name}</div>
          </Col>
          <Col md={2}>
            <div className="f10-400 opacity5">
              Package
              <br />
              Price
            </div>
            <div className="f12-500 my-2">₹ {data.price}</div>
          </Col>
          <Col md={2}>
            <div className="f10-400 opacity5">
              Discounted <br />
              Price
            </div>
            <div className="f12-500 my-2">₹ {data.discountedPrice}</div>
          </Col>
          <Col md={1}>
            <div className="f10-400 opacity5">
              No. of
              <br /> Adults
            </div>
            <div className="f12-500 my-2">{data.adults}</div>
          </Col>
          {!ageRestriction && <Col md={1}>
            <div className="f10-400 opacity5">
              No. of
              <br /> Kids
            </div>
            <div className="f12-500 my-2">{data.kids}</div>
          </Col>}
          <Col md={3}>
            <div className="f10-400 opacity5 ml-3">Actions</div>
            <div className="my-2 d-flex">
              <IconButton className="mr-2" onClick={(e) => { e.preventDefault(); editPackage(data) }}>
                <Image
                  src={require("../../../../assets/images/UserManagement/editBlue.svg")}
                  alt="edit "
                  title="edit"
                  className="w-20px"
                />
              </IconButton>
              <IconButton onClick={(e) => { e.preventDefault(); deletePackage(data) }}>
                <Image
                  src={require("../../../../assets/images/UserManagement/delete-gray.svg")}
                  alt="delete "
                  title="delete"
                  className="w-20px"

                />
              </IconButton>
            </div>
          </Col>
        </Row>
        <Row className="pb-4">
          <Col md={3}>
            <div className="f10-400 opacity5">
              Can number of seats
              <br />
              be customized?
            </div>
            <div className="f12-500 my-2">{data.seatCustomized ? "Yes" : "No"}</div>
          </Col>
          <Col md={6}>
            <div className="f10-400 opacity5">Package Description</div>
            <div className="f12-500 my-2">
              <ReadMore
                text={data.desc}
                minLength={50}
                charLength={data.desc?.length || 10}
              />
            </div>
          </Col>

          <Col md={3}>
            <div className="f10-400 opacity5">Status</div>
            <div className="d-flex my-1">
              <Toggle
                checked={data.status}
                toggleFunction={() => onPackageStatusChange(data)}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </>
  );
};
export default AddedPackages;
